// src/services/unreadMessages.js
// Source unique du nombre de messages non lus par contact, partagée entre la
// page de messagerie (badges par conversation) et le reste de l'app (badge
// menu latéral, titre d'onglet). Alimentée par la socket partagée
// (src/services/socket.js) pour rester à jour même en dehors de /chat.
import { reactive } from 'vue';
import { getSocket } from './socket';
import { getUserIdFromToken } from './authService';

export const unreadMessagesState = reactive({ byContact: {} });

let initialized = false;

function increment(contactId) {
    unreadMessagesState.byContact[contactId] = (unreadMessagesState.byContact[contactId] || 0) + 1;
}

export function clearUnreadFor(contactId) {
    unreadMessagesState.byContact[contactId] = 0;
}

export function totalUnreadMessages() {
    return Object.values(unreadMessagesState.byContact).reduce((sum, n) => sum + (n || 0), 0);
}

export function resetUnreadMessages() {
    Object.keys(unreadMessagesState.byContact).forEach((key) => delete unreadMessagesState.byContact[key]);
    initialized = false;
}

export function initUnreadMessagesTracking() {
    if (initialized) return;
    initialized = true;

    const socket = getSocket();
    const currentUserId = getUserIdFromToken();

    // Backlog envoyé par le serveur juste après avoir rejoint sa room.
    socket.on('receive_unread_messages', (messages) => {
        messages.forEach((message) => {
            if (message.id_destinataire === currentUserId) increment(message.id_expediteur);
        });
    });

    socket.on('receive_message', (message) => {
        if (message.id_destinataire === currentUserId) increment(message.id_expediteur);
    });
}
